/* * 地图工具组件 * @module components/maptools/MapTools * @desc 用于操作地图 * @author zhaoting
*@date 2019年12月16日 */
<template>
  <div>
    <div :class="flagShowTools ? 'maptoolscontainer' : 'maptoolscontainer closemaptoolscontainer'">
      <ul>
        <li
          v-for="item in toolsData"
          :key="item.id"
          :class="item.type"
          @click="clickTool(item)"
          v-on:mouseenter.stop="upShow(item)"
        >
          <div class="icon"></div>
          <span class="li-span">{{ item.name }}</span>
        </li>
      </ul>
    </div>
    <div
      class="tool_opt"
      v-show="toolShow"
      v-on:mouseleave.stop="menuShow()"
      v-on:mouseenter.stop="upShowList()"
    >
      <ul>
        <li
          v-for="item in toolOptData"
          :key="item.id"
          @click="clickOptTool(item)"
          :class="item.type"
        >
          <div class="icon"></div>
          <span class="li-span">{{ item.name }}</span>
        </li>
      </ul>
    </div>
    <Modal
      id="layersTree"
      title="展示图层"
      v-model="layersModal"
      @on-cancel="hidelayers"
      draggable
      :styles="{ top: '115px' }"
      :mask-closable="false"
      :mask="false"
      :footer-hide="true"
      :width="330"
    >
      <LayerTree @layer-list-change="layerListChange"></LayerTree>
    </Modal>

    <Modal
      id="drawsModal"
      title="绘制功能"
      :styles="{ top: '120px' }"
      v-model="drawsModal"
      @on-cancel="closeDraw"
      draggable
      :mask-closable="false"
      :mask="false"
      :footer-hide="true"
      :width="420"
    >
      <drawTool v-if="initdrawsModal"></drawTool>
    </Modal>
    <Modal
      class="uploadModal"
      v-model="uploadModal"
      draggable
      :footer-hide="true"
      scrollable
      :mask="false"
      @on-cancel="closemodel"
      title="数据上传"
    >
      <Form :label-width="80" label-position="left">
        <FormItem label="图层名称" v-show="uploadData.saveLayer == 'true'">
          <Input type="text" v-model="uploadData.layerName" clearable placeholder="请输入" />
        </FormItem>
        <FormItem label="数据类型">
          <Select v-model="uploadData.type">
            <Option value="dwg">dwg</Option>
            <Option value="shp">shp</Option>
            <Option value="txt">txt</Option>
          </Select>
        </FormItem>
        <FormItem label="图层描述" v-show="uploadData.saveLayer == 'true'">
          <Input
            type="textarea"
            v-model="uploadData.description"
            placeholder="请输入图层描述"
            clearable
            style
          />
        </FormItem>
        <FormItem label="选择参考系">
          <!-- <Select filterable v-model="uploadData.inputCoordinate" :remote-method="remoteInputLike"> -->
          <Select filterable v-model="uploadData.inputCoordinate">
            <Option
              v-for="(item, index) in inputCoordinateArr"
              :key="index"
              :value="item"
              :label="item"
              >{{ item }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="图层保存">
          <RadioGroup v-model="uploadData.saveLayer">
            <Radio label="true">是</Radio>
            <Radio label="false">否</Radio>
          </RadioGroup>
        </FormItem>

        <FormItem label="注意：">
          <div class="importdesc" style="margin-left: 15px">
            <ul>
              <li>
                <p>上传dwg，shp，txt文件空间位置信息</p>
              </li>
              <li>
                <p @click.stop="handleDownload">点击此处下载示例导入文件</p>
              </li>
            </ul>
          </div>
        </FormItem>
      </Form>
      <Upload
        show-upload-list
        v-if="uploadData.type == 'dwg'"
        type="drag"
        :data="uploadData"
        action="/zituSpace/dwgToShp/uploadDwg/"
        :on-success="uploadSuccess23"
        accept=".dwg"
        :format="['dwg']"
        :headers="uploadHeader"
        :on-format-error="handleFormatError2"
        :before-upload="beforeupload"
        ref="dwgUpload"
      >
        <div style="padding: 20px 0">
          <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
          <p>点击上传或者将文件拖至此处</p>
        </div>
      </Upload>

      <Upload
        show-upload-list
        type="drag"
        v-if="uploadData.type == 'shp'"
        :data="uploadData"
        accept=".shp"
        :before-upload="shpBeforupload"
        :on-success="uploadSuccessShp"
        action=""
        :headers="uploadHeader"
        :format="['shp']"
        ref="shpUpload"
      >
        <div style="padding: 20px 0">
          <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
          <p>点击上传或者将文件拖至此处</p>
        </div>
      </Upload>
      <Upload
        show-upload-list
        type="drag"
        v-if="uploadData.type == 'txt'"
        :data="uploadData"
        accept=".txt"
        :on-success="uploadTxtSuccess"
        :before-upload="txtBeforupload"
        :on-error="uploadTxtError"
        :format="['txt']"
        :headers="uploadHeader"
        ref="txtUpload"
        action="/zituSpace/upload/addFeature"
      >
        <div style="padding: 20px 0">
          <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
          <p>点击上传或者将文件拖至此处</p>
        </div>
      </Upload>
      <Spin class="demo-spin-col" v-show="spinshow">
        <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
        <div>上传中...</div>
      </Spin>
      <div class="uploadBtns">
        <!-- <Button type="primary" style="margin-right:10px" @click="uploadModalSubmit">确定</Button> -->
        <Button @click="cancelSub">取消</Button>
      </div>
    </Modal>
    <!-- 导出shp和text数据 -->
    <exportShpAndText v-if="flagExportShpAndText" @closeLayer="closeLayerShp" />
    <!-- 行政区定位 -->
    <selectArea
      v-if="flagSelectArea"
      @closeLayerArea="closeLayerArea"
      ref="selectArea"
      @selectAreaData="selectAreaData"
    />
    <!-- <div class="jsLayer">当前图层为：{{ nowTopLayerName || '暂无' }}</div> -->
  </div>
</template>
<script>
import MapTools from './MapTools';

export default MapTools;
</script>
<style lang="less" scoped>
.uploadBtns {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.maptoolscontainer {
  position: absolute;
  top: 10px;
  right: 400px;
  height: 34px;
  z-index: 99;
  font-size: 12px;
  line-height: 22px;
  padding-left: 5px;
  padding-right: 5px;
  text-align: center;
  background-color: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  box-shadow: 1px 2px 1px rgba(0, 0, 0, 0.15);
  padding-top: 6px;
  padding-bottom: 6px;
  transition: all 0.5s;
  ul {
    display: flex;
    flex-flow: row;
    align-items: center;
    margin-top: 0px;
    list-style: none;
    padding-inline-start: 0px;
    li {
      border-left: 1px #eee solid;
      padding-left: 6px;
      padding-right: 6px;
      box-sizing: border-box;
      min-width: 60px;
      img {
        display: inline-block;
        vertical-align: middle;
      }
      .li-span {
        display: inline-block;
        vertical-align: middle;
        font-family: MicrosoftYaHei;
        font-size: -1px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: -1px;
        color: #333;
        margin-top: -10px;
      }
    }
    li:hover {
      cursor: pointer;
    }

    li:first-child {
      border-left: 0px;
      width: 74px;
    }
  }
}
.closemaptoolscontainer {
  position: absolute;
  top: 10px;
  left: 10px;
  height: 34px;
  z-index: 99;
  transition: all 0.5s;
}
#layersTree,
#drawsModal {
  /deep/ .ivu-modal-header {
    padding: 8px 16px;
  }
  /deep/ .ivu-modal-header-inner {
    font-size: 14px !important;
  }
  /deep/ .ivu-modal-close {
    top: 1px;
  }
  /deep/ .ivu-modal-content {
    right: -140%;
  }
  /deep/ .ivu-modal-body {
    height: 450px;
    overflow-x: hidden;
    overflow-y: auto;
  }
}

#layer-title {
  width: 270px;
  height: 40px;
  position: absolute;
  right: 50px;
  top: 120px;
  background-color: #0099fa;
  z-index: 3;
}

#title {
  color: white;
  margin-top: 8px;
  margin-left: 23px;
  position: absolute;
  height: 20px;
  width: 100%;
}

#layer-pop {
  width: 270px;
  height: 290px;
  position: absolute;
  top: 160px;
  right: 50px;
  border: 1px solid #666;
  border-radius: 2px;
  background-color: #fff;
  z-index: 3;
  overflow: auto;
}

#layer-pop > .title {
  font-size: 12px;
  margin-top: 5px;
  margin-left: 10px;
}

#layer-pop li {
  font-size: 12px;
  padding-left: 20px;
  height: auto;
  line-height: 30px;
  border-bottom: 1px solid #999;
}

#layer-pop li > .opa {
  font-size: 10px;
  border: 1px solid #ccc;
  border-radius: 2px;
  padding: 2px;
  width: 26px;
  height: 18px;
  outline: none;
  color: #ef0907;
  margin-left: 5px;
  cursor: text;
}

#layer-pop li > .opa:focus {
  outline: none;
}

li {
  cursor: pointer;
}
.maptoolscontainer .icon {
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
  display: inline-block;
  margin-right: 0.6rem;
}

// .maptoolscontainer ul {
//   display: grid;
//   grid-template-columns: repeat(6, 16.66%);
//   height: 100%;
// }
.maptoolscontainer > ul > li {
  display: flex;
  justify-content: center;
  align-items: center;
}

.maptoolscontainer ul li .li-span {
  margin: 0;
}

.maptoolscontainer .tool-layer .icon {
  background-image: url(../../../static/img/tool/tool_tc.png);
}

.maptoolscontainer .tool-layer:hover .icon {
  background-image: url(../../../static/img/tool/tool_tc_click.png);
}

.maptoolscontainer .distin .icon {
  background-image: url(../../../static/img/tool/distin_un.png);
}

.maptoolscontainer .distin:hover .icon {
  background-image: url(../../../static/img/tool/distin.png) !important;
}

.maptoolscontainer .tool-construct .icon {
  background-image: url(../../../static/img/tool/tool_gj.png);
}

.maptoolscontainer .tool-construct:hover .icon {
  background-image: url(../../../static/img/tool/tool_gj_click.png);
}

.maptoolscontainer .tool-refresh .icon {
  background-image: url(../../../static/img/tool/tool_qc.png);
}

.maptoolscontainer .tool-refresh:hover .icon {
  background-image: url(../../../static/img/tool/tool_qc_click.png);
}

.maptoolscontainer .draw .icon {
  background-image: url(../../../static/img/tool/draw.png);
}

.maptoolscontainer .draw:hover .icon {
  background-image: url(../../../static/img/tool/draw_click.png);
}
.maptoolscontainer .export .icon {
  background-image: url(../../../static/img/tool/export.png);
}

.maptoolscontainer .export:hover .icon {
  background-image: url(../../../static/img/tool/export_click.png);
}
.maptoolscontainer .location .icon {
  background-image: url(../../../static/img/tool/location.png);
}

.maptoolscontainer .location:hover .icon {
  background-image: url(../../../static/img/tool/location_click.png);
}

.maptoolscontainer .tool-layer:hover .li-span,
.maptoolscontainer .distin:hover .li-span,
.maptoolscontainer .tool-construct:hover .li-span,
.maptoolscontainer .draw:hover .li-span,
.maptoolscontainer .export:hover .li-span,
.maptoolscontainer .location:hover .li-span,
.maptoolscontainer .import:hover .li-span,
.maptoolscontainer .print:hover .li-span,
.maptoolscontainer .printscreen:hover .li-span,
.maptoolscontainer .tool-refresh:hover .li-span {
  color: rgba(51, 136, 255, 0.8) !important;
}
.tool_opt {
  position: absolute;
  top: 45px;
  height: 34px;
  // right: 250px;
  z-index: 999;
  font-size: 12px;
  line-height: 22px;
  width: 214px;
  text-align: center;
}
.tool_opt ul {
  width: 29%;
  background-color: #ffffff;
  margin-left: 36%;
  border: 1px solid #f3ecec;
}
.tool_opt ul li {
  line-height: 32px;
  height: 32px;
  list-style: none;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}
.tool_opt ul li:hover {
  color: #0099fa;
}

.tool_opt .icon {
  float: left;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
  display: inline-block;
  margin-top: 10px;
  margin-right: 3px;
}

.tool_opt .fulls .icon {
  background-image: url(../../../static/img/tool/tool_full.png);
}

.tool_opt .fulls:hover .icon {
  background-image: url(../../../static/img/tool/tool_full_click.png);
}

.tool_opt .zoomIn .icon {
  background-image: url(../../../static/img/tool/zoomIn.png);
}

.tool_opt .zoomIn:hover .icon {
  background-image: url(../../../static/img/tool/zoomIn_click.png);
}

.tool_opt .zoomOut .icon {
  background-image: url(../../../static/img/tool/zoomOut.png);
}

.tool_opt .zoomOut:hover .icon {
  background-image: url(../../../static/img/tool/zoomOut_click.png);
}

.tool_opt .area .icon {
  background-image: url(../../../static/img/tool/tool_rect.png);
}

.tool_opt .area:hover .icon {
  background-image: url(../../../static/img/tool/tool_rect_click.png);
}

.tool_opt .distance .icon {
  background-image: url(../../../static/img/tool/tool_gj.png);
}

.tool_opt .distance:hover .icon {
  background-image: url(../../../static/img/tool/tool_gj_click.png);
}

.tool_opt .print .icon,
.maptoolscontainer .print .icon {
  background-image: url(../../../static/img/tool/print.png);
}

.tool_opt .print:hover .icon,
.maptoolscontainer .print:hover .icon {
  background-image: url(../../../static/img/tool/print_click.png);
}
.tool_opt .printscreen .icon,
.maptoolscontainer .printscreen .icon {
  background-image: url(../../../static/img/tool/printscreen.png);
}

.tool_opt .printscreen:hover .icon,
.maptoolscontainer .printscreen:hover .icon {
  background-image: url(../../../static/img/tool/printscreen_click.png);
}

.tool_opt .import .icon,
.maptoolscontainer .import .icon {
  background-image: url(../../../static/img/tool/import.png);
}

.tool_opt .import:hover .icon,
.maptoolscontainer .import:hover .icon {
  background-image: url(../../../static/img/tool/import_click.png);
}

.tool_opt .rectS .icon {
  background-image: url(../../../static/img/tool/tool_rect.png);
}

.tool_opt .rectS:hover .icon {
  background-image: url(../../../static/img/tool/tool_rect_click.png);
}

.tool_opt .ambius .icon {
  background-image: url(../../../static/img/tool/ambius.png);
}

.tool_opt .ambius:hover .icon {
  background-image: url(../../../static/img/tool/ambius_click.png);
}

.tool_opt .distin .icon {
  background-image: url(../../../static/img/tool/distin_un.png);
}

.tool_opt .distin:hover .icon {
  background-image: url(../../../static/img/tool/distin.png);
}

.tool_opt .reset .icon {
  background-image: url(../../../static/img/tool/tool_reset.png);
}

.tool_opt .reset:hover .icon {
  background-image: url(../../../static/img/tool/tool_reset_click.png);
}

.tool_opt .fulls:hover .li-span,
.tool_opt .zoomIn:hover .li-span,
.tool_opt .zoomOut:hover .li-span,
.tool_opt .rectS:hover .li-span,
.tool_opt .ambius:hover .li-span,
.tool_opt .print:hover .li-span,
.tool_opt .distin:hover .li-span,
.tool_opt .distance:hover .li-span,
.tool_opt .import:hover .li-span,
.tool_opt .reset:hover .li-span,
.tool_opt .area:hover .li-span {
  color: #0099fa !important;
}
.tool_opt ul li span {
  vertical-align: middle;
  font-family: MicrosoftYaHei;
  font-size: -1px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: -1px;
  color: #333;
  margin-top: 0px;
  display: inline-block;
  float: left;
}
.jsLayer {
  position: absolute;
  bottom: 8px;
  right: 420px;
  //   width: 140px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  background: rgba(0, 60, 136, 0.3);
  color: #fff;
  margin-right: 10px;
  border-radius: 4px;
  border-bottom: 1px solid #fff;
  padding: 0 5px;
  z-index: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/maptools/MapTools.vue